import "./Header.css";
import {
    Search,
    ShoppingCart,
    User
} from "lucide-react";

function Header() {

    return (

        <header className="header">

            <div className="header__logo">

                <h1 className="logo-title">
                    FarmFox
                </h1>

                <span className="logo-tagline">
                    Premium Mithila Makhana
                </span>

            </div>

            <nav className="header__nav">

                <a href="/">
                    Shop
                    <span className="arrow">▼</span>
                </a>

                <a href="/">
                    Collections
                </a>

                <a href="/">
                    Best Sellers
                </a>

                <a href="/">
                    Combos
                </a>

                <a href="/">
                    Gift Boxes
                </a>

            </nav>

            <div className="header__actions">

                <div className="search-box">

                    <input
                        type="text"
                        placeholder="Search Premium Makhana..."
                    />

                    <Search size={18} />

                </div>

                <div className="icon-btn">
                    <User size={20} />
                </div>

                <button className="cart-btn">

                    <ShoppingCart size={18} />

                    <span>Cart</span>

                </button>

            </div>

        </header>

    );

}

export default Header;